// extracted by mini-css-extract-plugin
export var actionBox = "payment-module--action-box--axjlJ";
export var button = "payment-module--button--QYfZH";
export var container = "payment-module--container--7ZtFD";
export var dateText = "payment-module--date-text--wlyWu";
export var infoBox = "payment-module--info-box--hMADh";
export var statusText = "payment-module--status-text--Am91v";